import React, { useContext, useState } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext'

function AddProfileName() {

    const appState = useContext(StateContext);

    const [name, setName] = useState("")
    const [message, setMessage] = useState("")

    async function addNameHandler(e) {
        e.preventDefault();

        try {
            const authorRef = firestore.collection("authors");

            const data = {
                user_id: appState.userId,
                name: name,
                profile_image: "https://camillahardilla.com/wp-content/uploads/2020/07/my-recipes-logo.png"
            }
            authorRef.add(data)
            setMessage("Lagt til!")
        } catch (error) {
            setMessage("Noe gikk galt")
        }

    }

    return (
        <form onSubmit={addNameHandler}>
            <label>Ditt navn</label>
            <input value={name} onChange={e => setName(e.target.value)} className="form-control mb-2" />
            {message && <div> {message} </div>}
            <button className="btn btn-primary">Lagre</button>
        </form>
    )
}
export default AddProfileName